import { createContext, useContext } from 'react';
import { NO_CAPABILITIES } from './pursuitReadTypes';
export const PursuitRecordContext = createContext({
    captureProjectId: '',
    zouProjectId: '',
    header: undefined,
    capabilities: NO_CAPABILITIES,
    correlationId: ''
});
/** The pursuit record the section is rendered in (provided by PursuitRecordLayout, flag on). */ export function usePursuitRecord() {
    return useContext(PursuitRecordContext);
}
